import { config } from '@/configs/env';
import { apiFetch } from '@/lib/api-service';
import type { Brand, TopKeywords } from '@/types';

type TrendingKeywordsResponse = {
  topBrands: Brand[];
  topKeywords: TopKeywords[];
};

export async function getTrendingKeywords(): Promise<TrendingKeywordsResponse> {
  const response = await apiFetch<TrendingKeywordsResponse>(
    `${config.LOTUS_ANALYTICS_ENDPOINT}/trending-keywords`,
    {
      cache: 'force-cache',
      revalidate: 300,
      tags: ['trending-keywords'],
    }
  );

  return response;
}
